export function debounce(func, wait, immediate) {
  let timeout;
  return function() {
    let context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}

export function flatten(arr = []) {
  return arr.reduce((a, b) => a.concat(b), []);
}

export function intersection(arr) {
  const arrs = [...arguments];
  return arrs.reduce((a, b) => a.filter((c) => b.includes(c)));
}

export function keyBy(array, key) {
  return (array || []).reduce((r, x) => ({ ...r, [key ? x[key] : x]: x }), {});
}

export function omit(obj, key) {
  const { [key]: o, ...result } = obj;
  return result;
}

export function partition(arr, fn) {
  return Object.values(
    arr.reduce(
      (arr, item) => {
        if (fn(item)) {
          arr.true.push(item);
        } else {
          arr.false.push(item);
        }

        return arr;
      },
      {
        true: [],
        false: [],
      },
    ),
  );
}

export function pick(object, keys = []) {
  return keys.reduce((obj, key) => {
    if (object && object.hasOwnProperty(key)) {
      obj[key] = object[key];
    }
    return obj;
  }, {});
}

export function pickBy(object) {
  const obj = {};
  for (const key in object) {
    if (object[key]) {
      obj[key] = object[key];
    }
  }
  return obj;
}

export function remove(arr, fn) {
  let i = arr.length;
  const removedArray = [];
  while (i--) {
    const el = arr[i];
    if (fn(el)) {
      arr.splice(i, 1);
      removedArray.splice(0, 0, el);
    }
  }

  return removedArray;
}

export function sortBy(arr, key) {
  return arr.concat().sort((a, b) => (a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0));
}

export function throttle(func, timeFrame) {
  let lastTime = 0;
  return function(...args) {
    let now = new Date();
    if (now - lastTime >= timeFrame) {
      func(...args);
      lastTime = now;
    }
  };
}

export function without(arr) {
  const [a, ...b] = arguments;
  return arr.filter((value) => {
    return !b.includes(value);
  });
}
